// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database'
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBCa4h1raMmsex0Icd4UCEZDRbyvsUCYRA",
  authDomain: "inventory-management-sys-f846d.firebaseapp.com",
  databaseURL: "https://inventory-management-sys-f846d-default-rtdb.firebaseio.com",
  projectId: "inventory-management-sys-f846d",
  storageBucket: "inventory-management-sys-f846d.appspot.com",
  messagingSenderId: "866228682517",
  appId: "1:866228682517:web:3a8c3f748bba1999aa331c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app)
//  firebase.storage();

export default app;